import { render, staticRenderFns } from "./MatchPersonCondition.vue?vue&type=template&id=7298c221"
import script from "./MatchPersonCondition.vue?vue&type=script&lang=js"
export * from "./MatchPersonCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports